import type { ReceivingDisposition } from "@redotech/cockroachdb-codegen/tables/fulfillment/receiving-disposition";

/** Failed GET must stay undefined; only a successful GET may store null. */
export function receivingDispositionFromSettingsGet(
  getSucceeded: boolean,
  disposition: ReceivingDisposition | null,
): ReceivingDisposition | null | undefined {
  return getSucceeded ? disposition : undefined;
}

export function receivingDispositionForSave(
  loaded: ReceivingDisposition | null | undefined,
  formDisposition: ReceivingDisposition | null,
): ReceivingDisposition | null | undefined {
  return loaded === undefined ? undefined : formDisposition;
}
